import React, { useEffect, useRef, useState } from "react"
import $ from "jquery"
window.$ = window.jQuery = $
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css"
// import "datatables.net-dt";
import "datatables.net-bs4"
import axios from "axios"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import { deleteUser, EditUser } from "services/ApiService"
import { toast, ToastContainer } from "react-toastify"
import Swal from "sweetalert2"


const CountryAvgData = ({ apiURL, idName, countries }) => {
  const tableRef = useRef(null)
  const token = localStorage.getItem("authorizedToken")
  const [tableData, setTableData] = useState([])
 
  const fetchData = (dataTablesData, callback) => {
    $("#customLoader").show()
    const reqObj = {
      ...dataTablesData,
    }
    axios
      .get(apiURL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        const res = response.data
        $("#customLoader").hide()
        callback({
          draw: dataTablesData.draw,
          recordsTotal: res.recordsTotal,
          recordsFiltered: res.recordsFiltered,
          data: res.data,
        })
        setTableData(res.data)
      })
      .catch(err => {
        if (err.response && err.response.status === 401) {
          localStorage.clear()
          window.location.reload()
        } else {
          console.error("Error fetching data:", err)
        }
      })
  }

  

  useEffect(() => {
    if (tableRef.current) {
      const table = $(tableRef.current).DataTable({
        processing: true,
        serverSide: true,
        ajax: fetchData,
        columns: [
         
          { data: "countryName", title: "Country Name", orderable: true },
          { data: "averageScore", title: "Score", orderable: true },
          { data: "userCount", title: "User Count", orderable: true },
       
        ],
        destroy: true,
        createdRow: row => {
          // Apply inline style to center text in each cell
          $("td", row).css("text-align", "center")
        },
        headerCallback: thead => {
          // Apply inline style to center text and set background color in header cells
          $("th", thead).css({
            "text-align": "center",
            "background-color": "#f2f2f2", // Change this to your desired color
          })
        },
      })
      // $(tableRef.current).on("click", ".edit-btn", function () {
      //   const data = table.row($(this).parents("tr")).data()
      //   editVUser(data)
      // })

      // $(tableRef.current).on("click", ".delete-btn", function () {
      //   const data = table.row($(this).parents("tr")).data()
      //   deleteVUser(data)
      // })
    }
  }, [idName])

  return (
    <div>
      <ToastContainer />

      {/* <h2>Event List</h2> */}
      <div>
        <div className="table-responsive">
          <table
            id={`dataTable${idName}`}
            ref={tableRef}
            className="table table-hover table-bordered my-3"
            style={{ width: "100%", fontSize: 14, color: "#858D9D" }}
          ></table>
        </div>
      </div>
      {/* <table ref={tableRef} className="display" style={{ width: "100%" }}></table> */}
    
    </div>
  )
}

export default CountryAvgData
